import {emptyNPC, NPC} from './npcType';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

const initialState: NPC = emptyNPC;

export const npcSlice = createSlice({
    name: "npcSlice",
    initialState: initialState,
    reducers: {
        setNpc: (state, action: PayloadAction<NPC>) => {
            state.npcId = action.payload.npcId;
            state.npcName = action.payload.npcName;
            state.npcLevel = action.payload.npcLevel;
            state.CharacterSheet = action.payload.CharacterSheet;
            state.Class = action.payload.Class;
            state.Subclass = action.payload.Subclass;
            state.Race = action.payload.Race;
            state.Subrace = action.payload.Subrace;
        }
    }
});

export const {
    setNpc
} = npcSlice.actions;

export default npcSlice.reducer